// Build identity stamped at build time by scripts/with-version.js, which
// reads `git rev-parse --short HEAD` (+ `+dirty` suffix when the working
// tree has uncommitted changes) and the build timestamp into
// REACT_APP_BUILD_VERSION / REACT_APP_BUILD_TIME. CRA bakes any
// `REACT_APP_*` env var into the bundle. Fallbacks of 'dev' fire when
// the bundle was started without the with-version wrapper.
//
// The escape menu (EscapeMenu.js) renders both so we can verify at a
// glance which commit and which build time the running client is on —
// useful for diagnosing cache-staleness across the Cloudflare + Discord
// edge layers.
export const BUILD_VERSION = process.env.REACT_APP_BUILD_VERSION || 'dev';
export const BUILD_TIME = process.env.REACT_APP_BUILD_TIME || 'dev';
// Backward-compat alias; existing imports of VERSION keep working.
export const VERSION = BUILD_VERSION;

// Derive API and WebSocket URLs from window.location so the same build
// works in both local dev (http://localhost:3001 → :8001) and production
// (https://manager.hauntedspacehotel.com — everything behind nginx on
// standard ports, no port suffix needed).
//
// Local dev: CRA runs on :3001, Django/Daphne on :8001. The non-standard
// port means window.location.port is '3001', so we swap it to '8001'.
//
// Production: nginx serves React on :443. window.location.port is '' (or
// '443'). No port suffix needed — /api/ and /socket/ are on the same origin.
//
// Phase 0.5 note: hostname matching matters because Django SessionMiddleware
// sets sessionid with SameSite=Lax, and the browser treats `localhost` and
// `127.0.0.1` as DIFFERENT hosts for cookie purposes.
const LOCAL_DEV_API_PORT = '8001';
const BASE_HOST =
    typeof window !== 'undefined' && window.location && window.location.hostname
        ? window.location.hostname
        : '127.0.0.1';
const LOCATION_PORT =
    typeof window !== 'undefined' && window.location ? window.location.port : '';
const IS_LOCAL_DEV = LOCATION_PORT !== '' && LOCATION_PORT !== '443' && LOCATION_PORT !== '80';
const PROTOCOL =
    typeof window !== 'undefined' && window.location && window.location.protocol === 'https:'
        ? 'https:' : 'http:';
const WS_PROTOCOL = PROTOCOL === 'https:' ? 'wss:' : 'ws:';
const BASE_URL = IS_LOCAL_DEV
    ? `${BASE_HOST}:${LOCAL_DEV_API_PORT}/`
    : `${BASE_HOST}/`;

export const API_URL = `${PROTOCOL}//${BASE_URL}api/`;
export const SOCKET_URL = `${WS_PROTOCOL}//${BASE_URL}socket/`;

// Canonical asset base. Every game asset URL in the React app is derived from
// this constant — change it here and every image/texture/sound/video follows.
// Local dev: CRA serves public/game_static/ at this path automatically.
// Production: nginx serves the same path from disk on the DO droplet.
export const ASSETS_URL = '/game_static/';
// Old locations (kept for reference during migration):
// export const ASSETS_URL = 'https://s3.us-west-2.amazonaws.com/hauntedspacehotel.com/game_static/';
// export const ASSETS_URL = './build/';

// Asset URL constants. Every directory under game_static/ that holds
// images gets a constant; reference them instead of typing the path.
export const TEXTURES_URL = ASSETS_URL + 'textures/';
export const HOTEL_BOARDS_URL = ASSETS_URL + 'hotel_boards/';
export const OVERLAYS_URL = ASSETS_URL + 'overlays/';
export const UI_URL = ASSETS_URL + 'ui/';
export const VIDEO_URL = ASSETS_URL + 'video/';
export const LOGO_URL = UI_URL + 'HSHM_Logo_05172026_square.png';
export const FATE_DIE_URL = ASSETS_URL + 'fate_die/';
export const RANDOM_ACTION_DIE_URL = ASSETS_URL + 'random_action_die/';
export const FACTION_BACKS_URL = ASSETS_URL + 'faction_backs/';

// scp -r ./build hsh-1:/opt/node/current/app

// cd "C:\Users\Michael Clark\WebstormProjects\hsh-react-1"
// cmd /c mklink /d .\public\build "C:\Users\Michael Clark\Creative Cloud Files\HauntedSpaceHotel\build\"
// cmd /c rmdir .\public\build /q
